import { Message } from '../Hooks/useDownloadSummaryReport.ts';
import Typography from '@mui/material/Typography';
import { AutoHideSnackbar } from 'common/Snackbar/AutoHideSnackbar.tsx';
import Stack from '@mui/material/Stack';
import { AlertTitle } from 'common/Snackbar/AlertTitle.tsx';
import { Dispatch, SetStateAction } from 'react';
import Portal from '@mui/material/Portal';

type SummaryReportSnackbarProps = {
  message?: Message;
  setMessage: Dispatch<SetStateAction<Message | undefined>>;
};

export const SummaryReportSnackbar = ({ message, setMessage }: SummaryReportSnackbarProps) => {
  if (!message) {
    return null;
  }

  return (
    <Portal>
      <Stack>
        <AutoHideSnackbar
          severity={message.severity}
          open={!!message}
          onClose={() => {
            setMessage(undefined);
          }}
        >
          <AlertTitle>{message.title}</AlertTitle>
          <Typography sx={{ fontSize: '0.875rem' }}>{message.subtitle}</Typography>
        </AutoHideSnackbar>
      </Stack>
    </Portal>
  );
};
